import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { CloudStorageDialogComponent, CloudStorageDialogOptions } from '../../components/dialogs/cloud-storage-dialog/cloud-storage-dialog.component';
import { AsgardTab } from '../../core/asgard-tab';
import { BlobToPdfService } from '../blob-to-pdf.service';
import { CloudDlgManagerService } from '../cloud-storage/cloud-dlg-manager.service';
import { CloudServiceEnum, SaveStatusEnum } from '../cloud-storage/enums';
import { ExamModeRestrictionsService } from './exam-mode-restrictions.service';
import { TabService } from '../tab.service';
import { ModalWindowService } from '../ui/modal-window.service';

@Injectable({
  providedIn: 'root'
})
export class CompletedExamCreationService {
  private completedExam: File;

  get isCloudConnected(): boolean {
    return this.cloudManager.activeCloud !== CloudServiceEnum.CloudStorage;
  }

  constructor(
    private readonly bloblToPdfService: BlobToPdfService,
    private readonly examService: ExamModeRestrictionsService,
    private readonly modalWindowService: ModalWindowService,
    private readonly cloudManager: CloudDlgManagerService,
    private readonly tabService: TabService
  ) {
    // this.initSubscriptions();
  }

  async createCompletedExamFile(): Promise<File> {
    // TODO get completed exam from server
    const doc = await this.bloblToPdfService.GetPdfFromTab(this.getTabID(), this.getTitle());
    if (doc) {
      this.completedExam = doc;
      return Promise.resolve(doc);
    }
    return Promise.reject();
  }

  downloadCompletedExam(): void {
    FileSaver.saveAs(this.completedExam);
    this.examService.stopExam();
  }

  uploadCompletedExam(): void {
    // close preview dialog first
    this.modalWindowService.closeModal();

    // open cloud storage dialog
    const options: CloudStorageDialogOptions = {
      file: this.completedExam,
      showAllFiles: true,
      dialogStatus: SaveStatusEnum.CompletedExamModeFileSave
    };
    this.modalWindowService.createModalWindow(CloudStorageDialogComponent, options);
  }

  getTabID(): string {
    const tab = this.getTab();
    return tab ? tab.id : '';
  }

  private getTitle(): string {
    const tab = this.getTab();
    return tab ? tab.title : '';
  }

  private getTab(): AsgardTab | undefined {
    return this.tabService.allTabs.find(tab => tab.file.name.startsWith('Exam-'));
  }
}
